module.exports = __webpack_public_path__ + "static/media/3.Bottle Sprayer.f3b62a9d.jpeg";